module.exports = __webpack_public_path__ + "static/media/es.bb3fe520.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/es.svg
// module id = 1862
// module chunks = 0